import React from 'react';
import clsx from "clsx";
import {TabsProps} from "./Tabs.types";

export const RoundedTabs = <T, >(props: TabsProps<T>) => {

    const onChange = (tabId: T) => () => {
        props.onChange(tabId);
    }


    return (
            <div className="flex tablet:inline-flex bg-[#171A1E] rounded-[29px] my-[8px] max-tablet:p-[2px] max-tablet:gap-[2px] max-tablet:mx-[4px]">
            {props.tabs.map((tab, i) => (
                <div
                    key={i}
                    onClick={onChange(tab.value)}
                    className={clsx(
                        "cursor-pointer flex max-tablet:flex-1 max-tablet:basis-0 max-tablet:min-w-0 justify-center items-center text-[14px] font-normal tablet:text-[16px] rounded-[29px] h-[24px] px-[20px] tablet:min-w-[160px] tablet:min-h-[40px] desktop:min-h-[48px]",
                        props.value === tab.value ? "text-white bg-[#A73537] border border-black shadow-[0px_2px_4px_0px_rgba(0,0,0,0.10)]" : "text-[#727374]")}
                >
                    {tab.label}
                </div>
            ))}
        </div>
    )
}
